import { gql } from '@apollo/client';

export const lessonTextualConceptsFragment = gql`
  fragment LessonTextualConceptsFragment on Lesson {
    id
    textualConcepts {
      id
      description
    }
  }
`;

export const GET_TEXTUAL_CONCEPTS = gql`
  query GetTextualConcepts {
    textualConcepts {
      id
      description
    }
  }
`;

export const ADD_TEXTUAL_CONCEPTS = gql`
  mutation AddTextualConcepts($input: AddLessonTextualConceptInput!) {
    addLessonTextualConcept(input: $input) {
      ...LessonTextualConceptsFragment
    }
  }
  ${lessonTextualConceptsFragment}
`;

export const DELETE_TEXTUAL_CONCEPTS = gql`
  mutation DeleteTextualConcepts($input: DeleteLessonTextualConceptInput!) {
    deleteLessonTextualConcept(input: $input) {
      ...LessonTextualConceptsFragment
    }
  }
  ${lessonTextualConceptsFragment}
`;
